import { Model } from 'backbone';
import { getLogger } from '../../logging/logger';
import { ARCADE_EVENTS } from './arcade.types';

/**
 * @typedef {import('./arcade.types').PageOptions} PageOptions
 * @typedef {import('./arcade.types').ArcadeOptions} ArcadeOptions
 * @typedef {import('../../manager/audioManager.types').AudioManagerOptions} AudioManagerOptions
 */

const logger = getLogger('ArcadeModel');

/**
 * @class ArcadeModel
 * @extends {Model<ArcadeOptions>}
 */
export default class ArcadeModel extends Model {
	/** @returns {Partial<ArcadeOptions>} */
	defaults() {
		return {
			arcadeName: '',
			disableHeader: false,
			skin: '',
			skinModules: '',
			arcadeBg: '',
			bgAudio: undefined,
			entitlementEntity: '',
			pages: [],
			accountVariant: '',
			cognitoCheckDisabled: true,
			audioManager: undefined,
			helpPopUp: undefined,
			sprites: undefined,
		};
	}

	url() {
		return this.get('contentUrl') || '';
	}

	initialize() {
		logger.log(`[${this.initialize.name}]`);

		return Promise.resolve()
			.then(() => {
				if (this.url()) {
					return this.fetch();
				}
				return Promise.resolve();
			})
			.then(() => {
				this.hydratePagesData();
				this.trigger(ARCADE_EVENTS.initialized);
				return this;
			});
	}

	hydratePagesData() {
		logger.log(`[${this.hydratePagesData.name}]`);

		const { pages: allPages = [] } = this.attributes;
		allPages.forEach((page) => {
			// Convert page ids to full page data objects
			page.pages = (page.pages || [])
				.map((pageId) => {
					if (typeof pageId === 'object') {
						// Page data has already been hydrated
						return pageId;
					}

					const targetPage = allPages.find(({ id = '' }) => id === pageId);
					if (!targetPage) {
						logger.warn(`Cannot find page "${pageId}" to populate into "${page.id}"`);
					}
					return targetPage;
				})
				.filter((value) => !!value);
		});

		return this;
	}
}
